import FormInput from "@/components/Form/FormInput";
import { useTrans } from "@/translations";

import { FC } from "react";
import { UseFormReturn } from "react-hook-form";

export type WasteRoomFormData = {
  name: string;
  bluetoothScaleName?: string;
};

export const WasteRoomForm: FC<{
  formHandler: UseFormReturn<WasteRoomFormData>;
  isEdit?: boolean;
}> = ({ formHandler, isEdit }) => {
  const { t } = useTrans();
  const {
    register,
    formState: { errors },
  } = formHandler;

  return (
    <form onSubmit={(e) => e.preventDefault()}>
      <div className="mb-6">
        <FormInput
          name="name"
          label={t("importLabels:accessParentName")}
          register={register}
          error={errors?.name}
          required
        />
      </div>

      {isEdit && (
        <div className="mb-6">
          <FormInput
            name="bluetoothScaleName"
            label={t("drawerLabels:bluetoothScaleName")}
            register={register}
            error={errors?.bluetoothScaleName}
          />
        </div>
      )}
    </form>
  );
};
